import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

export type ClickOutsideEvent = { clickedElement?: HTMLElement; escKeyPress?: boolean };

/**
 * @deprecated Remove directive when the new cv click outside directive replaces `appClickOutside` in board language selector,
 * dashboard language selector, dashboard search, sidebar, slide out tab and toggle tip.
 */
@Directive({
    selector: '[appClickOutside]',
    standalone: false
})
export class ClickOutsideDirective {
  @Output() appClickOutside = new EventEmitter<ClickOutsideEvent>();

  constructor(private elementRef: ElementRef<HTMLElement>) {}

  @HostListener('document:click', ['$event.target']) onClick(target: HTMLElement) {
    const clickedInside = this.elementRef.nativeElement.contains(target);
    if (!clickedInside) {
      this.appClickOutside.emit({ clickedElement: target });
    }
  }

  // this should have own directive. this is not related to click outside functionality
  // Refer to CVClickOutsideDirective for what to do next
  @HostListener('document:keydown.escape', ['$event']) onKeydown() {
    this.appClickOutside.emit({ escKeyPress: true });
  }

}
